import React from 'react';
import PropTypes from 'prop-types';
import './CandleButton.css';

/**
 * Animated candle flame SVG component
 * Creates a realistic flickering flame effect using CSS animations
 */
const CandleFlame = ({ size = 24, className = '' }) => {
  return (
    <svg
      className={`candle-flame ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Outer glow */}
      <defs>
        <radialGradient id="flameGlow" cx="50%" cy="70%" r="50%">
          <stop offset="0%" stopColor="rgba(255, 200, 100, 0.4)" />
          <stop offset="100%" stopColor="rgba(255, 200, 100, 0)" />
        </radialGradient>
        <linearGradient id="flameGradient" x1="50%" y1="100%" x2="50%" y2="0%">
          <stop offset="0%" stopColor="#ff9500" />
          <stop offset="30%" stopColor="#ff6b00" />
          <stop offset="70%" stopColor="#ffcc00" />
          <stop offset="100%" stopColor="#fff4cc" />
        </linearGradient>
        <linearGradient id="flameInner" x1="50%" y1="100%" x2="50%" y2="0%">
          <stop offset="0%" stopColor="#ff7700" />
          <stop offset="50%" stopColor="#ffdd44" />
          <stop offset="100%" stopColor="#ffffee" />
        </linearGradient>
      </defs>

      {/* Glow effect */}
      <ellipse
        className="flame-glow"
        cx="12"
        cy="14"
        rx="8"
        ry="10"
        fill="url(#flameGlow)"
      />

      {/* Outer flame */}
      <path
        className="flame-outer"
        d="M12 3C12 3 8 8 8 13C8 15.5 9.5 18 12 18C14.5 18 16 15.5 16 13C16 8 12 3 12 3Z"
        fill="url(#flameGradient)"
      />

      {/* Inner flame */}
      <path
        className="flame-inner"
        d="M12 7C12 7 10 10 10 13C10 14.5 10.8 16 12 16C13.2 16 14 14.5 14 13C14 10 12 7 12 7Z"
        fill="url(#flameInner)"
      />

      {/* Bright core */}
      <ellipse
        className="flame-core"
        cx="12"
        cy="14"
        rx="1.5"
        ry="2"
        fill="#ffffee"
      />

      {/* Candle base */}
      <rect
        className="candle-base"
        x="10"
        y="18"
        width="4"
        height="4"
        rx="0.5"
        fill="#e8dcc8"
      />
      <rect
        className="candle-wick"
        x="11.5"
        y="16"
        width="1"
        height="2"
        fill="#333"
      />
    </svg>
  );
};

CandleFlame.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default CandleFlame;
